export const STRING = 'STRING';
